module.exports = __webpack_public_path__ + "img/commonly.5140ca35.png";